<template>
	<div class='container'>
		<div class='content'>
			<div v-if='loading'>
				<div class='container-loader'>
					{{ $t('general.loading') }}
				</div>
			</div>
				
			<div class='error text-error' v-if="!loading">
				{{ error }}
			</div>
		</div>
	</div>
</template>

<script>

import { container } from '../services/container'
import { User } from '../core/User'

export default {
	data () {
		return {
			loading: true,
			error: ''
		}
	},
	mounted () {
		var provider = this.$route.params.provider

		this.loading = true

		container.get('services.oauth').providerSignInCode(provider, this.$route.query)

		.then(response => {
			var redirect = container.get('services.cookies').get('redirect_logged_url', '/')
			container.get('services.cookies').remove('redirect_logged_url')

			container.get('services.oauth').authenticate()

			.then(response => {
				this.$root.updateUser(new User(response.body.data.resource))
				this.$router.replace(redirect ? redirect : '/')
			})

			.catch(e => {
				console.log(e)
			})
			
		})

		.catch(response => {
			this.error = this.$t(response.body.message)
			this.loading = false
		})
	}
}

</script>

<style scoped>
	.content {
		padding: 20px;
	}

</style>
